// import { BrowserRouter } from "react-router-dom";
// import AppRouter from "./router/AppRouter";


// function App() {
//   return (
//     <BrowserRouter>
//       <AppRouter />
//     </BrowserRouter>
//   );
// }

// export default App;


import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRouter from './router/AppRouter';
import { useContext, useEffect } from 'react';
import { LocationContext } from './context/LocationContext';
import { CartProvider } from './context/CartContext';
import LocationModal from './components/LocationModal';
import { PuffLoader } from 'react-spinners';

function App() {
  const { location, setIsLocationModalOpen } = useContext(LocationContext);
  const routerLocation = useLocation();

  useEffect(() => {
    if (!location) {
      setIsLocationModalOpen(true);
    } else {
      setIsLocationModalOpen(false);
    }
  }, [location, routerLocation, setIsLocationModalOpen]);

  if (!location) {
    return (
      <div className="">
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <PuffLoader color={"#83442B"} size={60} />
        </div>
        <LocationModal />
      </div>
    );
  }

  return (
    <div>
      <CartProvider>
        <AppRouter />
        <LocationModal />
      </CartProvider>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}